/** What a count badge on an icon button takes: a number, or a string such as `'0'` or `'–'`. */
export type NxCountBadgeValue = number | string | null | undefined;

export type NxCountBadgeTone = 'brand' | 'neutral' | 'warning' | 'danger';

/** `0`, `''`, `null` and `undefined` show nothing — pass the string `'0'` for a visible zero. */
export function hasCountBadge(badge: NxCountBadgeValue): boolean {
  return badge !== null && badge !== undefined && badge !== '' && badge !== 0;
}

/** Up to 99, then „99+“ — a badge wider than its button covers the icon. */
export function countBadgeText(badge: NxCountBadgeValue): string {
  return typeof badge === 'number' && badge > 99 ? '99+' : String(badge);
}

/**
 * The button's accessible name with its badge: „Aktivitäten (3)“, or
 * „Aktivitäten, 3 offen“ with `badgeLabel`. The badge itself is `aria-hidden`.
 */
export function countBadgeName(
  label: string,
  badge: NxCountBadgeValue,
  badgeLabel?: string
): string {
  if (!hasCountBadge(badge)) return label;
  return badgeLabel ? `${label}, ${badgeLabel}` : `${label} (${badge})`;
}
